export default function (nga, admin) {
    let entity = admin.getEntity('promo')
        .label('Promo')
    //.readOnly();

    entity.listView()
        .fields([
            nga.field('id').label('ID').isDetailLink(true).detailLinkRoute('show'),
            nga.field('name').label('NAME').isDetailLink(true).detailLinkRoute('show'),
            nga.field('email').label('EMAIL').isDetailLink(true).detailLinkRoute('show'),
            nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd'),
            nga.field('phone').label('PHONE').map(function (value, entry) {
                if (entry['user.phone'])
                    return entry['user.phone'];
            }),
            nga.field('user').label('USER').map(function (value, entry) {
                if (entry['user.name'])
                    return entry['user.name'] + ' ' + (entry['user.surname'] || '');
            }).template('<entity-show type="\'user\'" id="entry.values[\'user.id\']" text="value"></entity-show>'),
            nga.field('licence').label('LICENCE').map(function (value, entry) {
                if (entry['licence.licence'])
                    return entry['licence.licence'];
            }).template('<entity-show type="\'licence\'" id="entry.values[\'licence.id\']" text="value"></entity-show>'),
            nga.field('used', 'boolean').label('USED')


        ])
        .sortDir('asc')
        .url('promos')
        .listActions(['edit', 'delete'])

    entity.creationView().fields([
        nga.field('name').label('NAME'),
        nga.field('email').label('EMAIL'),
        nga.field('phone').label('PHONE'),
        nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd'),
        nga.field('user', 'reference')
            .map(function(value, entry) {
                return entry['user.id'];
            })
            .targetEntity(nga.entity('user').url('users'))
            .targetField(nga.field('name').map(function (value, entry) {
                return entry['name'] + ' ' + (entry['surname'] || '');
            }))
            .perPage(0),
        nga.field('licence', 'reference')
            .map(function(value, entry) {
                return entry['licence.id'];
            })
            .targetEntity(nga.entity('licence').url('licences'))
            .targetField(nga.field('licence'))
            .perPage(0),
        nga.field('used', 'boolean').label('USED')
            .template('<ma-switch-field field="::field" value="value" entry="::entry"></ma-switch-field>')
    ]);

    entity.editionView().fields(entity.creationView().fields());
    entity.deletionView();

    return entity;
}


/** WEBPACK FOOTER **
 ** ./js/entities/promo/config.js
 **/